import { useDraggable, useDroppable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { Flex } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import {
  CanbanBoardType,
  CanbanViewCard,
  CanbanViewType,
  ColumnContentDiv,
  ColumnDiv,
  ColumnHeaderDiv,
  Dragger,
} from "..";
import { ParseFilterState } from "../../..";
import { ParseFields } from "../../../components/ParseFields";

type Props = {
  view: CanbanViewType;
  state: ParseFilterState;
  column: CanbanBoardType;
  isSortable?: boolean;
};

export default observer((props: Props) => {
  const { setNodeRef, isOver } = useDroppable({
    id: props.column.key,
  });

  const {
    attributes,
    listeners,
    setNodeRef: setNodeRefColumn,
    transform,
    isDragging,
  } = useDraggable({
    id: props.column.key,
    data: { data: props.state.data, origin: props.column.key, type: "COLUMN" },
  });

  return (
    <div
      ref={setNodeRefColumn}
      {...attributes}
      key={props.column.key}
      style={{
        transform: CSS.Translate.toString(transform),
        zIndex: isDragging ? 100 : "",
        position: isDragging ? "relative" : "static",
      }}
    >
      <ColumnDiv>
        <ColumnHeaderDiv>
          <Flex justify="start" align="center" gap="small">
            {props.isSortable ? (
              <Dragger
                {...listeners}
                icon="fa:grip-vertical"
                size={16}
                isdragging={isDragging ? "true" : "false"}
              />
            ) : null}
            {props.column.pointer ? (
              <ParseFields
                object={props.column.pointer}
                fields={props.column.pointerTitleFields}
              />
            ) : (
              props.column.label
            )}
          </Flex>
        </ColumnHeaderDiv>

        <ColumnContentDiv ref={setNodeRef}>
          {props.column.cards.map((card) => (
            <CanbanViewCard {...props} card={card} key={card.key} />
          ))}
        </ColumnContentDiv>
      </ColumnDiv>
    </div>
  );
});
